<template>
    <psi-dialog
        heading-color="accent darken-1"
        title="Change Program Icon/Logo"
        scrollable
        icon="mdi-image"
        @close="$emit('close')"
        hide-actions
    >
        <v-tabs v-model="tab">
            <v-tab>Choose Icon</v-tab>
            <v-tab>Upload Image</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-item-group :value="iconIndex" @change="onSelect">
                    <v-container>
                        <v-row wrap>
                            <template v-for="(icon, index) in icons">
                                <v-col :key="index">
                                    <v-item v-slot="{ active, toggle }">
                                        <v-card
                                            :elevation="active ? 20 : 6"
                                            @click="toggle"
                                            :style="active ? 'opacity:0.6' : ''"
                                        >
                                            <v-card-text>
                                                <div
                                                    class="d-flex"
                                                    style="width: 74px"
                                                >
                                                    <img
                                                        :src="icon"
                                                        width="64"
                                                    />
                                                    <v-spacer></v-spacer>
                                                    <v-icon
                                                        v-show="active"
                                                        small
                                                        >mdi-check-circle</v-icon
                                                    >
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-item>
                                </v-col>
                            </template>
                        </v-row>
                    </v-container>
                </v-item-group>
            </v-tab-item>
            <v-tab-item>
                <div class="text-center mt-4">
                    <v-image-input
                        v-model="image"
                        :image-quality="0.85"
                        clearable
                        image-format="jpeg"
                        @file-info="onFileInfo"
                    />
                </div>
                <div class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        :disabled="image === null"
                        :loading="loading"
                        @click="onSaveImage"
                    >
                        <v-icon class="mr-2">mdi-camera</v-icon>Save
                        Image</v-btn
                    >
                </div>
            </v-tab-item>
        </v-tabs-items>
    </psi-dialog>
</template>
<script>
import ProgramIcons from "../mixins/programIcons";
import VImageInput from "vuetify-image-input";
import api from "../api";

export default {
    name: "program-icon-select",
    mixins: [ProgramIcons],
    components: {
        VImageInput,
    },
    props: {
        icon_filepath: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            selectedIconFilePath: this.icon_filepath,
            tab: 0,
            image: null,
            fileInfo: {},
            loading: false,
        };
    },
    computed: {
        iconIndex() {
            return this.icons.findIndex((icon) => icon === this.icon_filepath);
        },
    },
    methods: {
        onSelect(index) {
            this.selectedIconFilePath = this.icons[index];
            this.$emit("select", this.selectedIconFilePath);
        },
        onFileInfo(fileInfo) {
            this.fileInfo = fileInfo;
        },
        async onSaveImage() {
            this.loading = true;
            const filePath = await api.saveLogoImage(this.image);
            console.log(filePath);
            this.loading = false;
            this.$emit("select", filePath);
        },
    },
};
</script>

<style scoped>
</style>